import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesItemEditarComponent {
  data
  idProyecto
  onClose
  guardar = false

  $onInit() {
    this.copia = Object.assign({}, this.data)
  }

  cerrar() {
    this.data = Object.assign(this.data, this.copia)
    this.onClose()
  }

  finalizar(){
    this.onClose()
  }

}

module.component('viaticosConfiguracionProyectoResponsablesItemEditar', {
  controller: ViaticosConfiguracionProyectoResponsablesItemEditarComponent,
  template,
  bindings: {
    data: '<',
    idProyecto: '<',
    onClose: '&',
  },
})




// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/item/editar/component.js